import {useMutation} from '@tanstack/react-query';
import {type CompanyRegistrationFormData} from '@openapi/company-registration-form';
import {type ValidateErrorResponse} from '@prtimes-msw/types/company-registration-form';
import {type UseFormReturn} from 'react-hook-form';
import {postValidate} from '../operations/post-validate';
import {type FormSchema} from '@/features/company-registration/form';
import {noticeError} from '@/utils/noticeError';
import {useToast} from '@/hooks/use-toast';

export const usePostValidateMutation = (form: UseFormReturn<FormSchema>) => {
  const {showErrorToast} = useToast();

  const mutation = useMutation({
    mutationKey: ['postValidate'],
    mutationFn: async (body: CompanyRegistrationFormData) => postValidate(body),
    async onError(error) {
      if (!(error instanceof Response) || error.status !== 400) {
        showErrorToast(
          '予期せぬエラーが発生しました。もう一度お試しください。',
        );
        throw error;
      }

      const errorBody = (await error.json()) as ValidateErrorResponse;

      for (const error of errorBody.errors) {
        if (error.field !== undefined) {
          form.setError(error.field, {
            message: error.message.ja,
          });
        }
      }

      form.setFocus(errorBody.errors[0].field);

      noticeError('企業登録申請ページ：バックエンドバリデーションエラー', {
        backendErrorFields: JSON.stringify(errorBody.errors),
      });
    },
  });

  return mutation;
};
